import React from "react";
import "./vves.css";

// Import the image for SHRI. NAGESH.V. RAO
import jtSecretaryImage from "../assets/jt secretary.e3580b7929645707e933_compressed.webp";
import genSecretaryImage from "../assets/gen-secretary-image.jpeg";

const VVES = () => {
  return (
    <div className="vves-page">

      {/* Leadership Desk Section */}
            <section
              className="inside-block inside-block--leadership"
              data-aos="fade-up"
            >
              <h3 className="leadership-title">Leadership Desk</h3>
      
              {/* Combined Card for SHRI. SADASHIV SAWRIKAR & SHRI. ADITYA GODE */}
              <div
                className="leadership-card"
                data-aos="fade-up"
                data-aos-delay="200"
              >
                <h4 className="leadership-name">SHRI. SADASHIV SAWRIKAR</h4>
                <p className="leadership-role">PRESIDENT</p>
                <p className="leadership-bio">
                  Shri Sadashiv Sawrikar is the President of the Vivek Vardhini Education
                  Society, playing a pivotal role in shaping the society's direction and
                  vision for the future. His leadership inspires academic excellence and
                  societal growth.
                </p>
                
                <h4 className="leadership-name">SHRI. ADITYA GODSE</h4>
                <p className="leadership-role">HON. GEN. SECRETARY</p>
                <p className="leadership-bio">
                  Shri Aditya Godse is an educationist and visionary leader with academic
                  credentials in B.Tech (ECE), M.Tech (CSE), and MBA from JNTUH. He began
                  his professional journey with Genesis Solutions Pvt. Ltd. In 2005, later
                  heading Genesis Software Training Institute (2007–2012). He went on to
                  serve as Director of Malla Reddy College of Engineering for Women
                  (2010–2014), where he contributed significantly to academic and
                  institutional development. In 2017, he was instrumental in establishing
                  Keshav Smarak Junior College, which today nurtures over 1,000 students.
                  From 2022 to 2025, he also served as Director of Keshav Memorial College
                  of Engineering (KMCE), successfully setting up the institution and
                  placing it on the path of growth and excellence. Currently, as Hon.
                  General Secretary of Vivek Vardhini Education Society, Shri Aditya Godse
                  continues to guide educational initiatives with vision, dedication, and
                  a commitment to academic excellence.
                </p>
                <div className="leadership-image">
        <img src={genSecretaryImage} alt="SHRI. ADITYA GODSE" />
      </div>
              </div>
              
              
              
              {/* Secretary Desk Title and SHRI. NAGESH.V. RAO Card with Image */}
              <h4 className="secretary-title">Secretary Desk</h4>
      
                {/* NEW MESSAGE CARD — placed BEFORE Mr. Nagesh profile */}
              <div className="leadership-card" data-aos="fade-up" data-aos-delay="500">
                <p className="leadership-bio">
                  It is with immense pride and gratitude that I welcome you to our new CBSE institution—an inspiring chapter built on the rich 100-year legacy of the Vivek Vardhini Education Society. For a century, our institution has stood as a beacon of learning, values, and purposeful education, and today, we carry this heritage forward into a new era shaped by innovation, curiosity, and global thinking. At Vivek Vardhini Creative Minds School, we are committed to blending the timeless strengths of our culture with the dynamic needs of modern education—ensuring that every child grows not only in knowledge, but also in confidence, character, and creativity. To our dear parents, thank you for trusting us with the future of your children; together, we will nurture a generation that thinks boldly and acts responsibly. And to our students, I encourage you to dream fearlessly, explore deeply, and make the most of every opportunity that comes your way. With a legacy behind us and a bright future ahead, we stand ready to shape minds that will lead, inspire, and transform the world.
                  
                </p>
                
                <h4 className="leadership-name">SHRI. NAGESH.V. RAO</h4>
                <p className="leadership-role">HON. JOINT SECRETARY</p>
                <p className="leadership-bio">
                  Mr. Nagesh V. Rao, a native of Hyderabad, has the rare distinction of
                  being both a product and a proud contributor to the Vivek Vardhini
                  Education Society. Born and raised in Hyderabad, he completed his
                  entire academic journey from nursery through Class X, and later his
                  collegiate education within the institutions run by the Society. His
                  deep-rooted association with Vivek Vardhini has not only shaped his
                  educational foundation but also instilled in him a lifelong commitment
                  to learning, discipline, and community service. After completing his
                  formal education, Mr. Rao chose to serve the nation through a career
                  in public administration, with a focus on legal and taxation matters.
                  He joined the Central Excise, Service Tax, and Customs Department,
                  where he built a distinguished career spanning several decades. Rising
                  through the ranks with dedication, diligence, and integrity, he
                  retired in 2014 as a Superintendent. During his tenure in the Department, Mr. Rao, acquired comprehensive expertise in the domains of indirect taxation, regulatory enforcement, and legal compliance. He was widely respected for his thorough understanding of tax laws and procedures, as well as for his balanced approach to administration and enforcement. His experience and insight into the evolving landscape of taxation made him a valued officer and a dependable colleague.
                             Following his retirement, Mr. Rao, continued to dedicate his time and expertise to the development of the community and educational causes. Recognizing the value of his vast professional experience and legal acumen, the Vivek Vardhini Education Society invited him to support its operations and governance. He has since become an integral part of the Society’s functioning, offering guidance on matters related to administration, compliance, and institutional development.
                               Mr. Rao is widely regarded as an asset to the Society—not only because of his professional capabilities, but also due to his deep personal commitment to the values and vision of Vivek Vardhini. His journey stands as a testament to the transformative power of education and the importance of giving back to the institutions that shape us.
      
                </p>
                <div className="leadership-image">
                  <img src={jtSecretaryImage} alt="SHRI. NAGESH.V. RAO" />
                </div>
              </div>
            </section>
    </div>
  );
};

export default VVES;




